// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3glI1","newExpiryDate":"styles_newExpiryDate__1376w","footer":"styles_footer__Ey6Qm"};